<div [style.height]="height" (clickOutside)="closeDatepicker($event)" class="app-datepicker">
  <div class="app-datepicker__picker">
    <input
      matInput
      #dateInput
      autocomplete="off"
      appOnlyNumbers
      class="app-datepicker__input"
      [formControl]="dateControl"
      [allowMultipleDots]="true"
      [placeholder]="placeholder ? placeholder : ('Choose a date' | translate)"
      (click)="openDatepicker($event, menu)"
      (focus)="onFocus($event)"
      (keydown.enter)="changed(dateControl.value, 'enter'); openOnEnterDatepicker($event, menu)" />
    <i (click)="openDatepicker($event, menu)" [ngClass]="datepickerIcon" class="icon app-datepicker__logo"></i>
  </div>
</div>

<ng-template #menu>
  <div class="calendar-container">
    <mat-calendar
      #calendar
      [minDate]="_minDate"
      (click)="$event.stopPropagation()"
      (selectedChange)="changed($event)"
      [selected]="parseCalendarDate(dateControl.value)"></mat-calendar>
  </div>
</ng-template>
